module.exports = __webpack_public_path__ + "img/CRC1_CD4Tconv.c4cc6e11.png";